"use client";

import type { Locale } from "@i18n/react";
import type { Router } from "next/router";
import type { ReactNode } from "react";

export let useServerInsertedHTML: (callback: () => ReactNode) => void;
if (process.env.NEXT_PUBLIC_FRAMEWORK === "next") {
  useServerInsertedHTML = require("next/navigation").useServerInsertedHTML;
} else {
  useServerInsertedHTML = () => {};
}
let initialized = false;
const initPromises: Promise<void>[] = [];

export let useSetLocale: () => {
  setLocale: ({ locale }: { locale: Locale }) => void;
};
if (process.env.NEXT_PUBLIC_FRAMEWORK === "next")
  useSetLocale = require("@i18n/next").useSetLocale;
else if (process.env.VITE_FRAMEWORK === "rr") {
  const p = import("@i18n/rr").then(({ useSetLocale: useSetLocaleRr }) => {
    useSetLocale = useSetLocaleRr;
  });
  initPromises.push(p);
} else
  /** TODO */
  useSetLocale = () => ({ setLocale: () => {} });

type UseParams = <
  T extends Record<string, string> = Record<string, string>,
>() => T;
export let useParams: UseParams;
if (process.env.NEXT_PUBLIC_FRAMEWORK === "next")
  useParams = require("next/navigation").useParams;
else if (process.env.VITE_FRAMEWORK === "rr") {
  const p = import("react-router").then((mod) => {
    useParams = mod.useParams as UseParams;
    usePath = () => mod.useLocation().pathname;
    useSearch = () => mod.useSearchParams()[0];
  });
  initPromises.push(p);
} else
  /** TODO */
  useParams = <T extends Record<string, string> = Record<string, string>>() =>
    ({}) as T;

export let usePath: () => string;
if (process.env.NEXT_PUBLIC_FRAMEWORK === "next")
  usePath = require("@i18n/next").usePathname;
else if (process.env.VITE_FRAMEWORK === "rr")
  import("@i18n/rr").then(({ usePath: rrUsePath }) => {
    usePath = rrUsePath;
  });
else usePath = () => window?.location?.pathname;

export let useSearch: () => URLSearchParams;
if (process.env.NEXT_PUBLIC_FRAMEWORK === "next")
  useSearch = require("next/navigation").useSearchParams;
else if (process.env.VITE_FRAMEWORK === "rr")
  import("react-router").then(({ useSearchParams }) => {
    useSearch = () => useSearchParams()[0];
  });
else useSearch = () => new URLSearchParams(window?.location?.search);

export let useRouter: () => Pick<
  Router,
  "push" | "replace" | "forward" | "back"
>;
if (process.env.NEXT_PUBLIC_FRAMEWORK === "next")
  useRouter = require("next/navigation").useRouter;
/* TODO */ else
  useRouter = () => ({
    forward: async () => {
      history.forward();
      return true;
    },
    back: history.back,
    push: async (url: string) => {
      history.pushState(null, null, url);
      return true;
    },
    replace: async (url: string) => {
      history.replaceState(null, null, url);
      return true;
    },
  });

/**
 * Ensures all framework-specific modules are loaded before use.
 * For react-router apps, call this before rendering to avoid timing issues.
 */
export async function ensureFrameworkReady(): Promise<void> {
  if (initialized) return;
  if (initPromises.length > 0) {
    await Promise.all(initPromises);
  }
  initialized = true;
}
